<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Safety Reports</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Safety Reports
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>Safety Reports</h4>
                </div>

                <div class="card-body">
                    <div class="search-container pb-2">
                        <form @submit.prevent="paginatedData">
                            <div class="row">
                                <div class="col-md-3 d-flex align-items-center">
                                    <input id="search-term" type="text"
                                           class="table-search form-control form-control-sm"
                                           placeholder="🔍 Search this table (Pickup, Drop Address)"
                                           v-model="searchTerm"
                                           @keyup="paginatedData"
                                    >
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Report Type</label><br/>
                                        <select class="form-control form-control-sm" v-model="filter.type">
                                            <option value="">All</option>
                                            <option value="safety">Safety</option>
                                            <option value="insurance">Insurance Claims</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Report Status</label><br/>
                                        <select class="form-control form-control-sm" v-model="filter.status">
                                            <option value="">All</option>
                                            <option value="pending">Pending</option>
                                            <option value="investigating">Investigating</option>
                                            <option value="resolved">Resolved</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>&nbsp;</label><br/>
                                        <button type="submit" class="btn btn-sm btn-primary glow mb-1 mb-sm-0" :disabled="isLoadingFilter">
                                            Apply Filter
                                            <i class="fa fa-spinner spinner" v-if="isLoadingFilter"></i>
                                        </button>
                                        <button type="reset" @click="resetFilter" class="btn btn-sm btn-warning glow mb-1 mb-sm-0">
                                            Reset Filter
                                        </button>
                                    </div>
                                </div>


                                <!--                            <div class="col-lg-3 col-md-4 col-sm-6 d-flex">-->
                                <!--                                <download-excel type="csv" :data="admins" :export-fields="exportFields">-->
                                <!--                                    <a href="#" class="export-link"><i class="fas fa-file-csv"></i> export to csv</a>-->
                                <!--                                    | &nbsp;-->
                                <!--                                </download-excel>-->
                                <!--                                <download-excel :data="admins" :fields="exportFields">-->
                                <!--                                    <a href="#" class="export-link text-warning"><i class="fa fa-file-excel-o"></i>-->
                                <!--                                        export to excel-->
                                <!--                                    </a>-->
                                <!--                                </download-excel>-->
                                <!--                            </div>-->
                            </div>
                        </form>
                    </div>

                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        @on-page-change="onPageChange"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="allSafetyReports"
                    >

                        <div slot="emptystate" class="loading-container">
                            <img src="/images/Spinner.svg" alt="">
                        </div>
                        <template slot="table-row" slot-scope="props">
                             <span v-if="props.column.field === 'sn'">
                                    {{ serialNo(props) }}
                             </span>
                            <span v-else-if="props.column.label === 'Report Id'">
                                <a :href="route('admin.safety-reports.show', props.row.id)">{{ props.row.id }}</a>
                             </span>
                            <span v-else-if="props.column.label === 'Passenger Details'">
                                     Name: <b>{{ props.row.passenger_name }}</b>  <br>
                                    Email: <b>{{ props.row.passenger_email }}</b>
                                </span>
                            <span v-else-if="props.column.label === 'Driver Details'">
                                    Name:  <b>{{ props.row.driver_name }}</b> <br>
                                    Email: <b>{{ props.row.driver_email }}</b>
                                </span>
                            <span v-else-if="props.column.label === 'Reporter'">
                                <b>{{ props.row.reporter_type }}</b>
                            </span>
                            <span v-else-if="props.column.field === 'status'"
                                  :class="'badge-glow badge badge-' + statusClass(props.row.status)"
                            >
                                {{ props.row.status }}
                            </span>
                            <span v-else-if="props.column.field === 'action'">
                                <span class="dropdown">
									<a id="btnSearchDrop2" data-toggle="dropdown" aria-haspopup="true"
                                       aria-expanded="false" class="dropdown-toggle dropdown-menu-right"><i
                                        class="fa fa-ellipsis-v"></i></a>
                                    <span aria-labelledby="btnSearchDrop2"
                                          class="dropdown-menu mt-1 dropdown-menu-right"
                                          x-placement="bottom-end"
                                          style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(0px, 19px, 0px);"
                                          x-out-of-boundaries="">
                                        <a class="dropdown-item text-secondary"
                                           :href="route('admin.safety-reports.show', props.row.id)">
                                            <i class="feather icon-eye"></i>
                                            View Report
                                        </a>
                                        <!--                                        <a href="#" class="dropdown-item">-->
                                        <!--                                           @click.prevent="updateStatus(props.row.id, props.row.is_active)"-->
                                        <!--                                                  <i class="feather icon-check"></i>-->
                                        <!--                                            {{ !props.row.is_active ? 'Activate ' : 'Deactivate ' }} Account-->
                                        <!--                                        </a>-->
                                    </span>
                                </span>
                            </span>
                        </template>
                    </vue-good-table>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';

export default {
    metaInfo: {title: 'Safety Reports'},
    props: ['reports', 'type'],
    name: "SafetyReportIndex",
    layout: Layout,

    data: () => ({
        filter: {
            type: '',
            status: ''
        },
        isLoadingFilter: false,
        allSafetyReports: [],
        totalRecords: 0,
        serverParams: {
            page: 1,
            perPage: 10
        },
        searchTrip: {},
        paginationOptions: {
            enabled: true,
            mode: 'pages',
            perPage: 10,
            perPageDropdown: [5, 10, 20, 50, 100, 200],
            dropdownAllowAll: false,
        },
        columns: [
            {label: 'S/N', field: 'sn'},
            {label: 'Report Id', field: 'id'},
            {label: 'Report type', field: 'report_type'},
            {label: 'Reporter', field: 'reporter_type'},
            {label: 'Passenger Details', field: 'passenger_name'},
            {label: 'Driver Details', field: 'driver_name'},
            {label: 'Status', field: 'status'},
            {label: 'Action', field: 'action'},
            // {label: 'Action', field: 'action', sortable: false},
        ],
        tableDataLoading: false,
        searchTerm: '',
    }),
    created() {
        this.allSafetyReports = this.reports.data
        this.totalRecords = this.reports.total
    },
    methods: {
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        },
        onPageChange(params) {
            this.updateParams({page: params.currentPage});
            this.paginatedData();
        },
        onPerPageChange(params) {
            this.updateParams({perPage: params.currentPerPage});
            this.paginatedData();
        },
        onSortChange(params) {
            this.serverParams.sort = {
                type: params[0].type,
                field: params[0].field,
            }
            this.paginatedData();
        },
        async paginatedData() {
            try {
                let url = route('admin.safety-reports.index') +
                    `?q=${this.searchTerm}&page=${this.serverParams.page}&perPage=${this.serverParams.perPage}&type=${this.filter.type}&status=${this.filter.status}`;
                let {data: {data: {reports}}} = await axios.get(url);

                this.totalRecords = reports.total;
                this.paginationOptions.perPage = reports.per_page;
                this.allSafetyReports = reports.data
            } catch (e) {
                console.log(e);
            }
        },

        async resetFilter() {
            this.filter = {
                type: '',
                status: ''
            }
            this.searchTerm = ""

            this.paginatedData();
        },

        serialNo(props) {
            return this.serverParams.page === 1 ? props.index + 1 : (this.serverParams.perPage *
                    (this.serverParams.page - 1)) +
                props.index + 1
        },
        statusClass(value) {
            if (value === 'pending' || value === 'submitted') {
                return "danger";
            }
            else if (value === 'investigating')
            {
                return "warning";
            } else if (value === 'resolved')
            {
                return "primary";
            }
        },
    }
}
</script>
